export { default } from './CarouselBlock';
